import type { Profile } from '../types';
import { supabase } from './supabase';

export async function fetchProfile(userId: string): Promise<Profile | null> {
  if (!supabase) return null;
  const { data, error } = await supabase.from('profiles').select('id, name, email, phone, role').eq('id', userId).maybeSingle();
  if (error || !data) return null;
  return data as Profile;
}

export async function saveProfile(profile: Profile) {
  if (!supabase) throw new Error('Configure o Supabase antes de salvar o perfil.');
  const { error } = await supabase.from('profiles').upsert({
    id: profile.id,
    name: profile.name,
    email: profile.email,
    phone: profile.phone,
  });
  if (error) throw new Error(error.message);
}
